import { Input, Slider as MantineSlider, SliderProps as MantineSliderProps } from "@mantine/core";
import styles from "./styles.module.css";

export interface SliderProps extends Omit<MantineSliderProps, "label"> {
  label?: string;
  error?: string;
  description?: string;
  withAsterisk?: boolean;
}

const Slider = ({ label, error, description, withAsterisk, ...props }: SliderProps) => {
  return (
    <Input.Wrapper
      label={label}
      error={error}
      description={description}
      withAsterisk={withAsterisk}
      classNames={{ label: styles.wrapperLabel }}
    >
      <MantineSlider
        classNames={{
          root: styles.root,
          label: styles.thumbLabel,
        }}
        {...props}
      />
    </Input.Wrapper>
  );
};

Slider.displayName = "Slider";

export default Slider;
